<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click=""><img src="@/assets/img/back.png" alt=""></p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">保存</p>-->
    </header>
    <div class="personalMain">
       <div  class="personalTop">
         <div class="personalTopNmae">
           <span>{{list.name}}</span>
           <span>{{list.salary}}</span>
         </div>

         <p class="personalTopP">
           <van-icon name="location-o" />
         <span>{{list.city}}</span>
         <span style="margin-left: 20px"><van-icon name="shop-o" /> {{list.work_year}}</span>
         <span><van-icon name="desktop-o" />{{list.edu}}</span>
         </p>
       </div>
      <div  class="personalTop">
        <h3>职位描述</h3>
        <p class="personalTopS">
          <!--<van-icon name="location-o" />-->
          <span>{{list.keywords}}</span>
          <span>
            <!--<van-icon name="shop-o" />-->
            电商</span>
          <!--<span><van-icon name="desktop-o" />本科</span>-->
        </p>

      </div>
      <div class="positionDiv" >
        <p>职位类型：{{list.position_type}}
        <span v-if="list.work_nature==1">全职</span>
        <span v-else-if="list.work_nature==2">兼职</span>
        <span v-else-if="list.work_nature==3">实习</span>
        </p>
        <p>职位亮点：{{list.welfare}}</p>
        <p>职位类型：{{list.position_type}}</p>
        <p>岗位职责：</p>
        <!--<p>{{list.desc}}</p>-->
        <p><van-field
          v-model="list.desc"
          rows="1"
          autosize
          type="textarea"
        /></p>
          <!--<textarea style="width: 100%;height: 20rem;border: none">-->
<!--职位类型：{{list.position_type}}-->
<!--职位亮点：气氛好 福利多多-->
<!--岗位职责:-->
<!--1.根据产品需求主导服务端程序的设计和开发；-->
<!--2.对新业务方向的相关方向提供开发和支持；-->
<!--3.参与优化或重构现有系统，支撑业务进一步发展；-->
<!--4.能够根据不同的业务需求，灵活快速的完成具有挑战行的项目。-->


<!--任职要求:-->
<!--1.根据产品需求主导服务端程序的设计和开发；-->
<!--2.对新业务方向的相关方向提供开发和支持；-->
<!--3.参与优化或重构现有系统，支撑业务进一步发展；-->
          <!--</textarea>-->

      </div>
      <div  class="personalTop">
        <h3>公司信息</h3>
        <div class="positionDetailsDiv">
          <div class="positionImg" >
            <img v-if="list.logo" :src="list.logo" alt="">
            <img v-else="" src="@/assets/img/lo.jpg" alt="">
          </div>
          <div class="positionDetails">
            <div>{{list.company_name}}</div>
            <div class="positionDetailsWord">
              <span v-if="list.scale==1">15人以下</span>
              <span v-else-if="list.scale==2">15人-50人</span>
              <span v-else-if="list.scale==3">50-150人</span>
              <span v-else-if="list.scale==4">150-500人</span>
              <span v-else-if="list.scale==5">500-2000人</span>
              <span v-else-if="list.scale==6">2000人以上</span>
              <span style="margin-left: 5px">| &nbsp;&nbsp;{{list.keywords}}</span>
              <span style="display: flex;padding-top: 2px">{{list.city}}·{{list.address}}</span>
            </div>
          </div>
        </div>
        <p class="personalTopS">
          <!--<van-icon name="location-o" />-->

        </p>
      </div>
    </div>
    <div class="inforName">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="sendJober()">投递简历</van-button>

    </div>
  </div>
</template>
<script>
  import {Toast} from 'vant';
  export default {
    name:'',
    data(){
      return {
        msg: "",
        list:{}
      }
    },
    mounted(){
      this.getDetailsPositioner()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getDetailsPositioner(){
        this.$api.getDetailsPosition({
          "userid":localStorage.getItem("userid"),
          "id":this.$route.params.id
        })
          .then(res=>{
            this.list=res
          })
          .catch(res=>{
          })
      },
      sendJober(){
//        this.$toast("点击图标");
        Toast({
          message: '顶部展示',
          position: 'top',
        });
        this.$api.sendJob({
          "user_id":localStorage.getItem("userid"),
          "job_id":this.$route.params.id,
          "company_id":this.$route.params.cid
        })
          .then(res=>{
            if(res.status==200){
             Toast({
                message: '投递成功',
//                position: 'top',
              });
              this.$router.push("/position")
            }else if(res.status==300){
              Toast({
                message: res.data,
//                position: 'top',
              });
            }
          })
          .catch(res=>{
            Toast({
              message: '投递失败',
              position: 'top',
            });
          })
      }
    }
  }
</script>
<style scoped="">
  /**{*/
    /*margin: 0;*/
    /*padding: 0;*/
  /*}*/
  .positionDiv{
    padding: 0 1rem;
    border: solid 1px #dedede;
    font-size: 15px;
  }
  .personalTopNmae{
   display: flex;
    justify-content: space-between;
    align-items: center;
  }.personalTopNmae span:first-child{
    font-size: 20px;
     }
  .personalTopNmae span:last-child{
    padding-right: 1rem;
    color:#07c160;
    font-size: 15px;
  }
  header{
    width: 100%;
    height: 56px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .personalMain{
    padding-top: 56px;
    padding-bottom: 50px;
    /*padding: 8rem 18px;*/
   /*padding:  8rem 18px 0 18px;*/
  }
  .personalTop{
    /*border-top:solid 7px #dedede ;*/
    border-bottom:solid 7px #dedede ;
    padding: 0 1rem;
    margin-top: 15px;
  }
  .personalTopP{
    font-size: 12px;
    color: grey;
  }
  .personalTopS{
    font-size:12px ;
  }
  .personalTopS span{
    background: #ececec;
    padding: 3px 8px;
    border-radius: 8px;
  }
.inforName{
  position: fixed;
  bottom: 0;
  width: 100%;
}
.positionImg{
  width: 40px;
  /*height: 50px;*/
}
  .positionImg img{
    width: 100%;
    /*height: 100%;*/
  }
  .positionDetailsDiv{
   display: flex;
  }
  .positionDetails span{
    /*display: block;*/
  }
  .positionDetailsWord{
    font-size: 13px;
    color: #8f8f94;
    padding-top: 5px;
  }
  .positionDetails{
  margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/detailsPosition.vue